import { FC } from 'react';

import { COLORS } from '@/shared/constants/colors';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { DeleteScenarioConfirmationModalProps } from '@/widgets/modals/types';

import { ScenarioConfirmationModal } from '../ScenarioActionConfirmationModalContainer';

export const DeleteScenarioConfirmationModal: FC<DeleteScenarioConfirmationModalProps> = ({
  onConfirm,
}) => {
  const { closeModal } = useModalsStore();

  const { t } = useTranslation('widgets/scenariosActions', {
    keyPrefix: 'deleteScenarioConfirmationModal',
  });

  const onDelete = () => {
    onConfirm();
    closeModal();
  };

  return (
    <ScenarioConfirmationModal
      cancelButtonText={t('cancelButton')}
      content={t('content')}
      onClose={closeModal}
      onSubmit={onDelete}
      submitButtonText={t('submitButton')}
      title={t('title')}
      submitButtonStyle={{ backgroundColor: COLORS.systemFlame200, color: COLORS.systemLight100 }}
    />
  );
};
